$(document).ready(function(){
  automodals();
  swipers();
  audios();
  searchBar();
  megamenu();
  productCard();
  quantitySelector();
  promoAddToCart();
  popup();
  hubspots();
  checkouts();
  rss();
  upsell();
});

function upsell(){
  $('[data-upsell-add]').on('click', function(){
    var id = $(this).attr('data-upsell-add');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'items': [{
          'id': id,
          'quantity': 1
        }]
      })
    })
    .then(response => {
      console.log(response);
      location.reload();
    })
    .catch((error) => {
      console.log(error);
    });
  });
}

function rss(){
  $('[data-rss]').each(function(){
    var blocks = $(this).find('.card');
    $.ajax({
      url: 'https://blog.enecta.it/rss.xml',
      type: "GET",
      dataType: 'xml',
      cache: false,
      success: function (data) {
        var items = $(data).find('item');
        for(var i=0;i<blocks.length;i++){
          var item = items[i];
          var block = blocks[i];

          var title = $(item).find('title').text();
          var link = $(item).find('link').text();
          var descrString = $(item).find('description').text();
          var img = $(descrString).find('img').first().attr('src');
          var descr = descrString.replace(/<\/?[^>]+(>|$)/g, ""); 

          $(block).find('[data-column-title]').text(title);
          $(block).find('[data-column-text]').text(descr);
          $(block).find('img').attr('src', img);
          $(block).find('img').removeAttr('srcset');
          $(block).find('[data-column-link]').attr('href', link);
          $(block).find('[data-column-link]').attr('target', '_blank');
        }
      },
      error: function(err){
        console.log(err);
      }
    });
  });
}

function automodals(){
  $('.modal-open').each(function(){
    new bootstrap.Modal(this).show();
  });
}

function swipers(){
  $('[data-swiper]').each(function(){
    var opt = {
      autoHeight: false
    };
    if($(this).attr('data-swiper-pagination') != undefined){
      opt.pagination = {
        el: ".swiper-pagination",
        dynamicBullets: true
      };
    }
    if($(this).attr('data-swiper-navigation') != undefined){
      opt.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if($(this).attr('data-swiper-scrollbar') != undefined){
      opt.scrollbar = {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: true
      };
    }
    if(parseInt($(this).attr('data-swiper-autoplay')) > 0){
      opt.autoplay = {
        delay: $(this).attr('data-swiper-autoplay'),
        disableOnInteraction: false,
      };
    }
    if($(this).attr('data-swiper-autowidth') != undefined){
      opt.slidesPerView = "auto";
      opt.spaceBetween = 0;
    }
    var swiper = new Swiper(this, opt);
  });
}

function audios(){
  $('.section-audio').each(function(){
    var play = $(this).find('[data-audio-play]');
    var pause = $(this).find('[data-audio-pause]');
    var restart = $(this).find('[data-audio-restart]');
    var actual = $(this).find('[data-audio-actual]');
    var duration = $(this).find('[data-audio-duration]');
    var progress = $(this).find('[data-audio-progress]');
    var audio = $(this).find('audio').get(0);
    var timer = false;

    $(duration).html(formatSeconds(audio.duration));

    $(play).on('click', function(){
      audio.play();
      $(play).addClass('d-none');
      $(pause).removeClass('d-none');
      $(restart).removeClass('d-none');
      timer = setInterval(showMinutes, 1000);
    });

    $(pause).on('click', function(){
      audio.pause();
      $(play).removeClass('d-none');
      $(pause).addClass('d-none');
      clearInterval(timer);
    });

    $(restart).on('click', function(){
      audio.pause();
      $(play).removeClass('d-none');
      $(pause).addClass('d-none');
      clearInterval(timer);
      audio.currentTime = 0;
      showMinutes();
    });

    function showMinutes(){
      $(actual).html(formatSeconds(audio.currentTime));
      var percentage = audio.currentTime / audio.duration * 100;
      $(progress).css('width', percentage+"%");
    }
  });
}

function formatSeconds(seconds){
  var s = seconds % 60;
  var m = (seconds - s) / 60; 
  s = parseInt(s);
  if(s < 10)
    s = "0"+s;
  if(m < 10)
    m = "0"+m;
  return m+":"+s;
}

function searchBar(){
  $('[data-search-toggle]').on('click', function(){
    $('body').toggleClass('search-open');
    if($('body').hasClass('search-open')){
      $('#header-search').focus();
    }
  });
}

function megamenu(){
  $('[data-megamenu-toggle]').on('mouseover', function(){
    var id = $(this).attr('data-megamenu-toggle');
    $('.megamenu').removeClass('open');
    $('[data-megamenu-toggle]').removeClass('active');
    if($(id).length){
      $(this).addClass('active');
      $(id).addClass('open');
    }
  });

  $('.megamenu').on('mouseleave', function(){
    $('[data-megamenu-toggle]').removeClass('active');
    $('.megamenu').removeClass('open');
  });
}

function productCard(){
  var adding = false;
  $('[data-card-add]').on('click', function(){
    if(!adding){
      adding = true;
      var form = $(this).parents('form');
      var text = $(this).html();
      var btn = this;
      $(this).html('<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');

      $.post(window.Shopify.routes.root + 'cart/add.js', $(form).serialize())
        .done(function(data) {
          Swal.fire({
            icon: 'success',
            title: translations.product_added_title,
            text: translations.product_added_message,
            customClass: {
              confirmButton: 'btn btn-primary'
            }
          });
          var element = JSON.parse(data);
          var qty = parseInt($(form).find('[name="quantity"]').val());
          updateCartQuantity(qty > 0 ? qty : 1);
          layerAddtocart([element]);
        })
        .fail(function(data) {
          try{
            var err = JSON.parse(data.responseText);
          } catch {
            var err = {message: 'Ops...', description: "Errore nell'aggiunta al carrello"};
          }
          Swal.fire({
            icon: 'error',
            title: err.message,
            text: err.description,
            customClass: {
              confirmButton: 'btn btn-primary'
            }
          });
        }).always(function(){
          $(btn).html(text);
          adding = false;
        });
    }
  });

  $('[data-card-variant]').on('change', function(){
    var card = $(this).parents('.product-card');
    var opt = $(this).find('option:selected');
    var price = $(opt).attr('data-card-variant-price');
    var compare = $(opt).attr('data-card-variant-compare');
    var percentage = $(opt).attr('data-card-variant-percentage');
    var priceText = $(card).find('[data-card-price]');
    var compareWrapper = $(card).find('[data-card-compare-wrapper]');
    var compareText = $(card).find('[data-card-compare]');
    var percentageText = $(card).find('[data-card-percentage]');
    if(compare.length > 0){
      $(compareText).text(compare);
      $(percentageText).text(percentage);
      $(compareWrapper).removeClass('d-none');
    } else {
      $(compareWrapper).addClass('d-none');
    }
    $(priceText).text(price);
  });
}

function quantitySelector(){
  $('[data-quantity-selector]').each(function(){
    qSelector(this);
  });

  function qSelector(el){
    var input = $(el).find('[data-quantity-input]');
    var minus = $(el).find('[data-quantity-minus]');
    var plus = $(el).find('[data-quantity-plus]');

    $(input).on('input', function(){
      setValue($(this).val());
    });
    
    $(minus).on('click', function(){
      setValue($(input).val(), -1);
    });
    
    $(plus).on('click', function(){
      setValue($(input).val(), 1);
    });

    function setValue(str, add=0){
      try{
        var val = parseInt(str);
        if(!val || val <= 0 || val == NaN){
          $(input).val(1);
        } else {
          if(add != 0)
            val = val + add;
          if(val > 0)
            $(input).val(val);
        }
      } catch(e){
        $(input).val(1);
      }
    }
  }
}

function promoAddToCart(){
  if(typeof cartdata !== 'undefined'){
    if(cartdata.items.length > 0){
      $.ajax({
        url: '/cart/add.js',
        type: "POST",
        data: JSON.stringify(cartdata),
        headers: {
            'Content-Type': 'application/json'
        },
        dataType: 'json',
        cache: false,
        success: function (data) {;
          if (data.items.length > 0) {
            layerAddtocart(data.items);
            location.href = '/cart'
          }
        }
      });
    }
  }
}

function popup(){
  if($('#popup-newsletter').length)
    createPopup('#popup-newsletter');

  function createPopup(el){
    var modal = new bootstrap.Modal(el, {});
    var trigger = $(el).attr('data-popup-trigger');
    var percentage = parseInt($(el).attr('data-popup-trigger-scroll'));
    var closed = getCookie('popup-closed');
    var expireDays = parseInt($(el).attr('data-popup-timer'));
    
    if(closed == undefined){
        triggers();
    }
    $(el).on('hidden.bs.modal', function(){
      if(expireDays > 0){
        setCookie("popup-closed", true, expireDays);
      }
    });

    function triggers(){
        if(trigger == 'now'){
          modal.show();
        }
        else if(trigger == 'delay'){
          var seconds = parseInt($(el).attr('data-popup-trigger-delay')) * 1000;
          setTimeout(function(){
            modal.show();
          }, seconds);
        }
        else if(trigger == 'scroll'){
          window.addEventListener('scroll', showOnScroll);
        }
        else if(trigger == 'inactivity'){
          onInactive(20*1000, function(){
            modal.show();
          });
        }
        else if(trigger == 'leave'){
          window.addEventListener('beforeunload', function(e) {
            modal.show();
            e.preventDefault();
            e.returnValue = ''; 
          });
        }
    }
    function showOnScroll(){
        if($(window).scrollTop() + $(window).height() >= $(document).height()/100*percentage) {
            modal.show();
            window.removeEventListener('scroll', showOnScroll);
        }
    }
    function onInactive(ms, cb){
        var wait = setTimeout(cb, ms); 
        document.onmousemove = document.mousedown = document.mouseup = document.onkeydown = document.onkeyup = document.focus = function(){
            clearTimeout(wait);
            wait = setTimeout(cb, ms);
        };
    }
      
  }
}

function hubspots(){
  $('[data-hubspot-container]').each(function(){
    var portalid = $(this).attr('data-hubspot-portalid');
    var formId = $(this).attr('data-hubspot-formid');
    var id = $(this).attr('id');
    hbspt.forms.create({
      region: "na1",
      portalId: portalid,
      formId: formId,
      target: '#'+id
    });
  })
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function deleteCookie(name) {
    var date = new Date();
    date.setTime(0);
    document.cookie = name + "=" + date.toUTCString() + "; path=/";
}

function checkouts(){
  $('[name="checkout"]').on('click', function(){
    var errors = [];
    $(this).parents('form').find('[required]').each(function(){
      if(($(this).attr('type') == 'checkbox' && !$(this).is(':checked')) || ($(this).val().trim() == '' || $(this).val() == undefined || $(this).val() == null)){
        errors.push(this);
        $(this).parents('.form-group').addClass('error');
        $(this).parents('.form-check').addClass('error');
      }
    });
    if(errors.length > 0){
      Swal.fire({
        icon: 'error',
        title: translations.checkout_error_title,
        text: translations.checkout_error_text,
        customClass: {
          confirmButton: 'btn btn-primary'
        }
      });
    } else {
      Swal.fire({
        icon: 'info',
        title: translations.checkout_going_title,
        text: translations.checkout_going_text,
        customClass: {
          confirmButton: 'btn btn-primary'
        }
      });
    }
  })
}

function layerAddtocart(elements){
  var products = [];
  $(elements).each(function(){
    products.push({
      id: this.variant_id,
      price: (this.final_price / 100).toFixed(2),
      name: this.product_title,
      category: this.product_type,
      quantity: this.quantity
    });
  });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      event: 'addToCart',
      products: products
  });
}

function updateCartQuantity(add){
  var counters = $('[data-cart-counter]');
  $(counters).each(function(){
    var n = parseInt($(this).text());
    $(this).text(n+add);
  });
  if($('#header-cart [data-cart-counter]').length == 0){
    $('#header-cart').append('<span class="position-absolute top-0 start-100 translate-middle badge rounded-pill" data-cart-counter>'+add+'</span>');
  }
}